import React from "react";

import { MedicalPlanMapping } from "Features/MedicalPlanMappings/medicalPlanMappings.types";

import { PlanSuiteOverviews } from "../components";
import { TitleSmall } from "Cobalt/Header";
import { Grid } from "Common/Grid";
import BodyText from "Theme/BodyText";

type LandingPageProps = {
  medicalPlanMappings: MedicalPlanMapping[];
};
const LandingPage = ({ medicalPlanMappings }: LandingPageProps) => {
  return (
    <>
      <div className="bg-white">
        <Grid py={6}>
          <TitleSmall mt={0} mb={5}>
            Compare Options for your Renewal
          </TitleSmall>
          <BodyText mb={4} weight="normal">
            We have some renewal options available for you.
            <br />
            Compare your current plans with your carrier&apos;s renewal packet as well as other proposals from top carriers in your region.
          </BodyText>
        </Grid>
      </div>
      <Grid py={6}>
        <PlanSuiteOverviews medicalPlanMappings={medicalPlanMappings} />
      </Grid>
    </>
  );
};

export default LandingPage;
